(function ($) {

    $(document).ready(function () {
        $('body').removeClass('fade-out');

        /*************************
        LAYOUT
        *************************/

        // Maintain hero viewheight even on mobile
        function calcVH() {
            $('#home-hero').innerHeight($(this).innerHeight());
        }
        calcVH();
        $(window).on('resize orientationchange', function () {
            calcVH();
        });


        /**************************
         * ANIMATIONS
         *************************/
        // $('.portfolio-grid-item').addClass('fade-out');
        // setTimeout(function () { $('.portfolio-grid-item').removeClass('fade-out'); }, 500);


        /*************************
         MENUS
         *************************/

        $('.hamburger').click(function () {
            $(this).toggleClass('is-active');
            var mobileMenu = $('.mobile-menu');

            if ($(this).hasClass('is-active')) {
                $('.mobile-menu').css('display', 'block');
                $('main').css('position', 'fixed');
            } else {
                mobileMenu.fadeOut(200);
                $('main').css('position', 'relative');
            }
        });


        /*************************
        Portfolio
        *************************/

        $('.portfolio-grid-item').click(function () {
            let id = $(this).data("id");
            $('.portfolio-grid-item').css('display', 'none');
            $('.portfolio-detail-container').css('display', 'none');
            $(`#company-detail-${id}`).css('display', 'block');

        });

        $('.portfolio-detail-close').click(function () {
            $('.portfolio-detail-container').css('display', 'none');
            $('.portfolio-grid-item').css('display', 'flex');
        });


        $('.prev-portfolio').click(function () {
            let currentItem = $(this).parent();
            currentItem.css('display', 'none');
            let prevItem = currentItem.prev().prev();
            prevItem.css('display', 'block');
        });

        $('.next-portfolio').click(function () {
            let currentItem = $(this).parent();
            currentItem.css('display', 'none');
            let nextItem = currentItem.next().next();
            nextItem.css('display', 'block');
        });

        let portfolioLocation = "all";
        let portfolioSector = "all";

        $('#portfolio-location').change(function (e) {

            portfolioLocation = e.target.value;

            $('.portfolio-grid-item').css('display', 'none');

            if (portfolioLocation == "all" && portfolioSector == "all") {
                $('.portfolio-grid-item').fadeIn();
                return;
            }

            if (portfolioLocation == "all") {
                $('.portfolio-grid-item').filter('[data-sector*=' + portfolioSector + ']').fadeIn();
            } else if (portfolioSector == "all") {
                $('.portfolio-grid-item').filter('[data-location*=' + portfolioLocation + ']').fadeIn();

            } else {
                $('.portfolio-grid-item').filter('[data-location*=' + portfolioLocation + ']').filter('[data-sector*=' + portfolioSector + ']').fadeIn();
            }

        });

        $('#portfolio-sector').change(function (e) {

            portfolioSector = e.target.value;


            $('.portfolio-grid-item').css('display', 'none');

            if (portfolioLocation == "all" && portfolioSector == "all") {
                $('.portfolio-grid-item').fadeIn();
                return;
            }

            if (portfolioSector == "all") {
                $('.portfolio-grid-item').filter('[data-location*=' + portfolioLocation + ']').fadeIn();
            } else if (portfolioLocation == "all") {
                $('.portfolio-grid-item').filter('[data-sector*=' + portfolioSector + ']').fadeIn();

            } else {
                $('.portfolio-grid-item').filter('[data-location*=' + portfolioLocation + ']').filter('[data-sector*=' + portfolioSector + ']').fadeIn();
            }


        });

        /*************************
        Team
        *************************/

        $('.team-filter').click(function () {
            $('.team-filter').removeClass('active');
            $(this).addClass('active');

            let value = $(this).data('category');

            if (value === 'all') {
                $('.team-grid-item').fadeIn();
            } else {
                $('.team-grid-item').css('display', 'none');
                $(`.category-${value}`).fadeIn();
            }

        });


        /*************************
        Investment Approach
        *************************/

        $('.button-filter').click(function () {
            $('.button-filter').removeClass('active');
            $(this).addClass('active');

            let value = $(this).data('panel');

            $('.panel').css('display', 'none');
            $(`#panel-${value}`).fadeIn();
        });

        $('.tile').click(function () {
            $('.tile').removeClass('active');
            $(this).addClass('active');
        });

        /*************************
        Helpers
        *************************/

        // Check if any part of the element is in the viewport
        $.fn.isInViewport = function () {
            var elementTop = $(this).offset().top;
            var elementBottom = elementTop + $(this).outerHeight();

            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();

            return elementBottom > viewportTop && elementTop < viewportBottom;
        };

        // Check if the element is fully in the viewport
        $.fn.isFullyVisible = function () {
            var win = $(window);

            var viewport = {
                top: win.scrollTop(),
                left: win.scrollLeft()
            };
            viewport.right = viewport.left + win.width();
            viewport.bottom = viewport.top + win.height();

            var elemtHeight = this.height(); // Get the full height of current element
            elemtHeight = Math.round(elemtHeight); // Round it to whole humber

            var bounds = this.offset(); // Coordinates of current element
            bounds.top = bounds.top + elemtHeight - 150;
            bounds.right = bounds.left + this.outerWidth();
            bounds.bottom = bounds.top + this.outerHeight();

            return !(
                viewport.right < bounds.left ||
                viewport.left > bounds.right ||
                viewport.bottom < bounds.top ||
                viewport.top > bounds.bottom
            );
        };

        // Example:
        // function startHomeAnimations() {
        //     if (homeInfo.isFullyVisible()) {
        //         $('#home-info--heading').removeClass("preload");
        //     }
        // }

        function isMobileDevice() {
            return (
                navigator.userAgent.match(/Android/i) ||
                navigator.userAgent.match(/webOS/i) ||
                navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/iPad/i) ||
                navigator.userAgent.match(/iPod/i) ||
                navigator.userAgent.match(/BlackBerry/i)
            );
        }
    });

})(jQuery);